export const acceptedFileExtensions = (supportedFileTypesSetting) => {
    return Object.values(supportedFileTypesSetting)
        .flat()
        .map((fileType) => fileType.contentType)
        .join(',');
};
